import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lowbackpain',
  templateUrl: './lowbackpain.component.html',
  styleUrls: ['./lowbackpain.component.scss']
})
export class LowbackpainComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  btnBackClick = function () {
    this.router.navigateByurl('/conditions');
  }
}
